import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import {TranslateService} from '@ngx-translate/core';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { first } from 'rxjs/operators';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';



@Component({
  selector: 'app-dialog-box-set-password',
  templateUrl: './dialog-box-set-password.component.html',
  styleUrls: ['./dialog-box-set-password.component.scss']
})
export class DialogBoxSetPasswordComponent {

  action: string;
  LOCAL_DATA: any;
  myControl = new FormControl();

  constructor(
    private service: UsersService,
    public dialogRef: MatDialogRef<DialogBoxSetPasswordComponent>,
    public translate: TranslateService,
    private storage: TokenStorageService,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.LOCAL_DATA = {};


  }


  doAction(): void{

    this.service.setPassword(this.LOCAL_DATA).pipe(first()).subscribe(
      data => {
        console.log(data);
        console.log('im here');
        this.openSnackBar("Se modificó la contraseña correctamente.","Cerrar");
        this.dialogRef.close();
      },
      error => {
        console.log(error);
        this.openSnackBar("No se pudo modificar la contraseña, verifique los datos ingresados.","Cerrar");
      }
    );

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }


}
